var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyBuyTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    viewBox: "0 0 31 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74618 19.7666C8.44623 19.7666 9.82439 18.4835 9.82439 16.9007C9.82439 15.3179 8.44623 14.0348 6.74618 14.0348C5.04613 14.0348 3.66797 15.3179 3.66797 16.9007C3.66797 18.4835 5.04613 19.7666 6.74618 19.7666Z",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8048 19.7666C26.5048 19.7666 27.883 18.4835 27.883 16.9007C27.883 15.3179 26.5048 14.0348 24.8048 14.0348C23.1047 14.0348 21.7266 15.3179 21.7266 16.9007C21.7266 18.4835 23.1047 19.7666 24.8048 19.7666Z",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6152 5.50061V10.5956C22.6152 10.914 22.8889 11.1688 23.2309 11.1688H29.3873",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8809 5.50061V16.9006",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8831 16.9007H28.8407C29.1143 16.9007 29.388 16.6459 29.388 16.3275V11.2962C29.388 11.2325 29.388 11.1688 29.3196 11.1051C29.3196 11.1051 26.3782 7.15652 25.4205 5.81909C25.2837 5.62803 25.1469 5.50066 24.9417 5.50066H19.8113V1.36099C19.8113 1.04256 19.5377 0.724121 19.1273 0.724121H1.88926C1.41043 0.724121 1 1.10624 1 1.55205V16.009C1 16.4548 1.41043 16.837 1.88926 16.837H4.00981",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89453 16.9007H22.0022",
    stroke: "#13294B",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyBuyTruck);
export default __webpack_public_path__ + "static/media/why-buy-truck.2f0fb827.svg";
export { ForwardRef as ReactComponent };